import { render, staticRenderFns } from "./expenseConfirmation.vue?vue&type=template&id=23663558&scoped=true"
import script from "./expenseConfirmation.vue?vue&type=script&lang=js"
export * from "./expenseConfirmation.vue?vue&type=script&lang=js"
import style0 from "./expenseConfirmation.vue?vue&type=style&index=0&id=23663558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23663558",
  null
  
)

export default component.exports